
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { logout as adminLogout } from "@/services/authService";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";
import logoImage from "@/assets/logo.png";


interface AdminHeaderProps {
  title: string;
}

const AdminHeader = ({ title }: AdminHeaderProps) => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      adminLogout();
      
      toast({
        title: "Logged out successfully",
        description: "You have been logged out of the admin dashboard",
      });
      
      navigate("/admin/login");
    } catch (error) {
      toast({
        title: "Logout failed",
        description: "There was a problem logging out. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <header className="bg-elfGreen text-white p-4 shadow-md">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img
            src={logoImage}
            alt="Elf Letter Bot Logo"
            className="h-10 w-auto"
          />
          <h1 className="text-xl font-bold">{title}</h1>
        </div>
        <div className="flex items-center space-x-4">
          <Link to="/" className="text-white hover:underline">
            View Site
          </Link>
          <Button 
            variant="outline" 
            className="bg-white text-elfGreen hover:bg-gray-100"
            onClick={handleLogout}
          >
            <LogOut size={16} className="mr-2" /> Logout
          </Button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
